import { createSlice } from '@reduxjs/toolkit';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from '../common/reducers/utilities';
import { inside } from '../common/utils/geoUtilities';
import { ensureArray } from '../common/utils/arrayUtilities';

export const compareJobFilters = (f1, f2) => f1.type === f2.type && f1.kind === f2.kind;

export const jobFilterSlice = createSlice({
    name: 'jobFilter',
    initialState: {
        filters: []
    },
    reducers: {
        set: (state, action) => {
            state.filters = action.payload
        },
        addOrUpdate: (state, action) => {
            for (const filter of ensureArray(action.payload)) {
                let idx = state.filters.findIndex(f => compareJobFilters(f, filter));
                if (idx >= 0) {
                    state.filters.splice(idx, 1, filter);
                } else {
                    state.filters.push(filter);
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => jobFilterSlice.getInitialState());
    }
});

// #region network operations
const fetchJobFilters = network => network.get('/api/v1/jobFilter', jobFilterSlice.actions.set);
export const insertJobFilter = (network, filter) => {
    network.put(`/api/v1/jobFilter/${encodeURIComponent(filter.type)}/${encodeURIComponent(filter.kind)}`, {}, jobFilterSlice.actions.addOrUpdate);
};
export const removeJobFilter = (network, filter) => {
    network.delete(`/api/v1/jobFilter/${encodeURIComponent(filter.type)}/${encodeURIComponent(filter.kind)}`, jobFilterSlice.actions.addOrUpdate);
};
// #endregion

// #region selectors
const selectJobFilters = state => state.jobFilter.filters;
// #endregion

// #region listeners
// #endregion

// #region utilities
const matchesZone = (filters, data) => {
    const activeZoneFilters = filters.filter(f => f.kind === 'Zone' && f.selected);
    if (activeZoneFilters.length === 0 || data.longitude === null || data.longitude === undefined || data.latitude === null || data.latitude === undefined) {
        return true;
    }
    return activeZoneFilters.some(f => inside([data.longitude, data.latitude], f.definition))
}
const matchesSite = (filters, data) => data.site === null || data.site === undefined || filters.length === 0 || filters.some(f => f.kind === 'Site' && f.type === data.site && !f.selected);
const matchesLevel = (filters, data) => data.level === null || data.level === undefined || filters.length === 0 || filters.some(f => f.kind === 'Level' && f.type === data.level && !f.selected);
const matchesType = (filters, data) => data.type === null || data.type === undefined || filters.length === 0 || filters.some(f => f.kind === 'Type' && f.type === data.type && !f.selected);
const matchesStatus = (filters, data) => data.status === null || data.status === undefined || filters.length === 0 || filters.some(f => f.kind === 'Status' && f.type === data.status && !f.selected);
export const matches = (filters, data, assistance, enableSites, enableLevels) => {
    return matchesZone(filters, data) && (
        (matchesType(filters, data) && (!enableLevels || matchesLevel(filters, data)) && (!enableSites || matchesSite(filters, data)) && matchesStatus(filters, data))
        || (matchesStatus(filters, data) && assistance?.some(a => matchesType(filters, { type: a.type }) && (!enableLevels || matchesLevel(filters, { level: a.level })) && (!enableSites || matchesSite(filters, { site: a.site }))))
        || filters.length === 0
    );
}
export const active = filters => filters.some(f => f.selected);
// #endregion

export const [useJobFilters] = dataHookFactory(selectJobFilters, { run: fetchJobFilters });

const reducerDetails = { name: jobFilterSlice.name, reducer: jobFilterSlice.reducer };
export default reducerDetails;